<template>
  <el-dialog title="提示" width="500px" :visible.sync="visible" class="tipsDialog" :modal-append-to-body="false"
    :close-on-click-modal="false" :class="visible ? 'flip-in-hor-bottom' : ''">
    <div class="info">
      设备正常，⽆预警信息
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      visible: false
    };
  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
.tipsDialog {
  .info {
    margin-left: 4px;
    color: var(--titleName-color);
  }

  /deep/ .el-dialog__title {
    font-size: 18px;
  }

  /deep/ .el-dialog__header{
    justify-content: flex-start !important;
  }

  /deep/ .el-input__inner {
    border-radius: 0px;
    border: 1px solid #c0e9ff1f;
    background: var(--input-bg);
    color: var(--titleName-color);
    border-radius: 0px;
  }

  /deep/ .el-form-item__label {
    font-size: 0.875rem;
  }
}

//添加动画
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }

  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219E82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219E82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}

.btn3:hover {
  background: #44D7B6;
}

.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44D7B6;
  background: transparent;
  color: #44D7B6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}

.btn4:hover {
  background: #44D7B655;
}

.pane-title {
  padding-left: 30px;
  font-size: 21px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5bb3bc;
  line-height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/tipsDialog.vue